import { Component, Inject } from '@angular/core';

import { EntityCheckboxListComponent } from '../../shared/checkbox-list/components/entity-checkbox-list.component';

import { StaticTypeService } from '../services/static-types.service';
import { ParcTechnologie } from '../entities/parc-technologie.entity';

@Component({
	selector: 'parc-technologie-checkbox-list',
	templateUrl: '../../shared/checkbox-list/components/entity-checkbox-list.html',
	styleUrls: ['../../shared/checkbox-list/components/entity-checkbox-list.css']
})
export class ParcTechnologieCheckboxListComponent extends EntityCheckboxListComponent<ParcTechnologie> {
	// Label du champ
	override label = "Technologie :"
	
	// Label de l'option neutre
	override wildcardOptionLabel = "Toutes"

	// Fonction determinant le label d'un parc
	override getEntityLabel = (technologie: ParcTechnologie) => technologie.label;

	constructor( //
		@Inject(StaticTypeService) private staticTypesService: StaticTypeService //
	) {
		super();
		this.staticTypesService.getParcTechnologieList().subscribe(
			(list: ParcTechnologie[]) => this.entities = list
		);
	}
}